// src/components/ElectricalSelectedItemsBox.js
"use client"

import React from "react"

const ElectricalSelectedItemsBox = ({
  lines,
  onEdit,
  onDelete,
  onSaveLines,
  savingLines,
}) => {
  return (
    <div className="rounded-xl border border-slate-200 bg-white p-4 shadow-sm flex flex-col">
      <h2 className="mb-3 text-sm font-semibold text-slate-900">
        Selected Items
      </h2>

      {/* SCROLLABLE LIST */}
      <div className="flex-1 max-h-64 overflow-y-auto">
        {lines.length === 0 ? (
          <p className="text-xs text-slate-500">
            No items yet. Add a system item on the left.
          </p>
        ) : (
          <table className="min-w-full text-xs">
            <thead>
              <tr className="border-b border-slate-200 bg-slate-50">
                <th className="px-2 py-1 text-left font-medium">Item</th>
                <th className="px-2 py-1 text-right font-medium">Units</th>
                <th className="px-2 py-1 text-right font-medium">Actions</th>
              </tr>
            </thead>

            <tbody>
              {lines.map((line) => (
                <tr key={line.id} className="border-b border-slate-100">
                  <td className="px-2 py-1 text-slate-800">
                    <div className="font-medium">{line.itemLabel}</div>
                    <div className="text-[10px] text-slate-500">{line.sectionType}</div>
                  </td>

                  <td className="px-2 py-1 text-right">{line.units}</td>

                  <td className="px-2 py-1 text-right">
                    <button
                      onClick={() => onEdit(line.id)}
                      className="mr-2 text-xs text-blue-600 hover:text-blue-800"
                    >
                      ✏️
                    </button>
                    <button
                      onClick={() => onDelete(line.id)}
                      className="text-xs text-red-600 hover:text-red-800"
                    >
                      🗑️
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>

      {/* SAVE BUTTON AT BOTTOM */}
      <div className="mt-4">
        <button
          onClick={onSaveLines}
          disabled={savingLines}
          className="w-full rounded-md bg-indigo-600 px-3 py-2 text-xs font-semibold text-white hover:bg-indigo-700 disabled:opacity-60"
        >
          {savingLines ? "Saving…" : "💾 Save Items to Estimate"}
        </button>
      </div>
    </div>
  )
}

export default ElectricalSelectedItemsBox
